import {Pipe, PipeTransform} from '@angular/core';
import {splitCamelCase} from '../utilities/Util';

@Pipe({
    name: 'splitCamelCase',
    standalone: false
})
export class SplitCamelCasePipe implements PipeTransform {
  transform(value: string, capitalizeFirst = true): string {
    return splitCamelCase(value, capitalizeFirst);
  }
}
